import { render, staticRenderFns } from "./ChooseExport.vue?vue&type=template&id=08ecfe42&scoped=true&"
import script from "./ChooseExport.vue?vue&type=script&lang=js&"
export * from "./ChooseExport.vue?vue&type=script&lang=js&"
import style0 from "./ChooseExport.vue?vue&type=style&index=0&id=08ecfe42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ecfe42",
  null
  
)

export default component.exports